<template>
    <div>
        <el-row :gutter="20">
            <carousel :perPageCustom="[[320, 1],[360, 2],[536, 3],[768, 3],[1024, 4], [1280, 5],[1440, 5],[1680, 5]]"
                :autoplay="doAutoplay" :autoplay-timeout="3000" :pagination-enabled="paginationEnabled"
                :pagination-active-color="paginationActiveColor" :pagination-color="paginationColor"
                :pagination-padding="paginationPadding" autoplayDirection="backward">
                <slide>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                        <el-card class="box-card">
                            <div class="cards-left">
                                <img :src="'/static/card-icons/cases.svg'" alt="cases-image">
                            </div>
                            <div class="cards-right">
                                <p>
                                    <span class="card-head">{{$t('Cases')}}</span>
                                    <span class="card-desc"></span>
                                </p>
                                <p class="digit">{{ this.countData.data['cases'] }}</p>
                            </div>
                            <img :src="'/static/card-icons/card-background.svg'" alt="hands-image">
                        </el-card>
                    </el-col>
                </slide>
                <slide>
                    <router-link :to="{path: '/dashboard', query: { at: 'case' }}">
                        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                            <el-card class="box-card">
                                <div class="cards-left">
                                    <img :src="'/static/card-icons/cases.svg'" alt="cases-image">
                                </div>
                                <div class="cards-right">
                                    <p>
                                        <span class="card-head">{{$t('Open Cases')}}</span>
                                        <span class="card-desc"></span>
                                    </p>
                                    <p class="digit">{{ this.countData.data['open_cases'] }}</p>
                                </div>
                                <img :src="'/static/card-icons/card-background.svg'" alt="hands-image">
                            </el-card>
                        </el-col>
                    </router-link>
                </slide>
                <slide>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" style="padding-right:0px">
                        <el-card class="box-card">
                            <div class="cards-left" >
                                <img :src="'/static/card-icons/confirm-cases.svg'" alt="Confirmed Cases-image">
                            </div>
                            <div class="cards-right">
                                <p>
                                    <span class="card-head">{{$t('Confirmed Cases')}}</span>
                                    <span class="card-desc"></span>
                                </p>
                                <span class="digit">{{ this.countData.data['confirmed_cases'] }}</span>
                            </div>
                            <img :src="'/static/card-icons/card-background.svg'" alt="hands-image">
                        </el-card>
                    </el-col>
                </slide>
                <slide>
                    <router-link :to="{path: '/dashboard', query: { at: 'contact' }}">
                        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                            <el-card class="box-card">
                                <div class="cards-left">
                                    <img :src="'/static/card-icons/contacts.svg'" alt="contacts-image">
                                </div>
                                <div class="cards-right">
                                    <p>
                                        <span class="card-head">{{$t('Contacts')}}</span>
                                        <span class="card-desc"></span>
                                    </p>
                                    <span class="digit">{{ this.countData.data.contact }}</span>
                                </div>
                                <img :src="'/static/card-icons/card-background.svg'" alt="hands-image">
                            </el-card>
                        </el-col>
                    </router-link>
                </slide>
                <slide>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                        <el-card class="box-card">
                            <div class="cards-left">
                                <img :src="'/static/card-icons/voter.svg'" alt="voter-image">
                            </div>
                            <div class="cards-right">
                                <p>
                                    <span class="card-head">{{$t('Voters')}}</span>
                                    <span class="card-desc"></span>
                                </p>
                                <span class="digit">{{ this.countData.data['voters'] }}</span>
                            </div>
                            <img :src="'/static/card-icons/card-background.svg'" alt="hands-image">
                        </el-card>
                    </el-col>
                </slide>
            </carousel>
        </el-row>
        <section>
            <div class="grid-stack" data-gs-width="12" data-gs-height="1">
                <div class="grid-stack-item" data-gs-no-resize="yes" data-gs-x="0" data-gs-y="0" data-gs-width="6"
                    data-gs-height="18">
                    <div class="header">
                        <h1># {{ $t('Cases') }}</h1>
                        <ul class="icon-list">
                            <li><a class="drag" href="javascript:void(0)" :title="$t('Drag')"><i class="icon-drag-drop"></i></a></li>
                        </ul>
                    </div>
                    <div class="my-content">
                        <div class="grid-stack-item-content">
                            <cases-votes-count></cases-votes-count>
                        </div>
                    </div>
                </div>
                <div class="grid-stack-item" data-gs-no-resize="yes" data-gs-x="6" data-gs-y="0" data-gs-width="6"
                    data-gs-height="18">
                    <div class="header">
                        <h1># {{ $t('Recent Activities') }}</h1>
                        <ul class="icon-list">
                            <li><a class="drag" href="javascript:void(0)" :title="$t('Drag')"><i class="icon-drag-drop"></i></a></li>
                        </ul>
                    </div>
                    <div class="my-content">
                        <div class="grid-stack-item-content recent-activities">
                            <div v-if="recentActivities.data.length > 0">
                                <el-card class="box-card" v-for="(activity) in recentActivities.data" :key="activity.id" >
                                    <div class="left-details">
                                        <p><span class="title-text">{{ $t('Name') }}:</span>
                                            {{ activity.name }}
                                        </p>
                                        <p><span class="title-text">{{ $t('What') }}:</span> <el-tag size="mini">{{ activity.model_name + ' ' + $options.filters.convertWordToPastTense(activity.action) }}</el-tag></p>                                        
                                    </div>
                                    <div class="right-details">
                                        <p><span class="title-text">{{ $t('Date') }}:</span> <span v-date-time-format="activity.created_at"></span></p>
                                    </div>
                                </el-card>
                            </div>
                            <el-card v-else>
                                <div class="details">
                                    <p style="width: 100%; padding-bottom: 15px; text-align: center;">{{ $t('No activity found.') }}</p>
                                </div>
                            </el-card>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<style lang="scss">
    .grid-stack {
        margin: 0 -10px;
    }    
</style>
<script>
    import Vue from 'vue';
    import VueCollapse from 'vue2-collapse';
    import gridstack from 'gridstack';
    Vue.use(VueCollapse);

    import {
        Carousel,
        Slide
    } from "vue-carousel";

    import CasesVotesCount from "../Widgets/chart/components/CasesVotesCount";
    export default {
        components: {
            Carousel,
            Slide,
            CasesVotesCount
        },
        data() {
            return {
                layout: [],
                countData: {
                    data: {}
                },
                recentActivities: {
                    data: {}
                },
                options: {
                    handle: '.drag',
                    animate: false,
                    cellHeight: 10,
                },
                doAutoplay: false,
                paginationEnabled: true,
                paginationActiveColor: 'var(--base-theme-color)',
                paginationColor: 'var(--table-theme-light-color)',
                paginationPadding: 5,
            };
        },
        mounted() {
            $('.grid-stack').gridstack(this.options);
            this.getAllCount();
            this.getRecentActivities();
        },
        methods: {
            getAllCount() {
                request({
                    url: "dashboard-get-all-count",
                    method: "get",
                    params: {}
                }).then(response => {
                    this.countData = response.data;
                });
            },
            getRecentActivities() {
                request({
                    url: "get-user-recent-activities",
                    method: "get",
                    params: {}
                }).then(response => {
                    this.recentActivities = response.data;
                });
            }
        },
    };
</script>


// WEBPACK FOOTER //
// src/components/Layout/Clubs/DashboardTab.vue